import toast from '../components/ToastMtd';

const ajaxErrorHandler = (err) => {
    let message = '';

    if (err.status === 404) {
        message = '[404] EORROR';
    } else if (err.timeout) {
        message = '请求超时，请重新查询！';
    } else {
        // message = JSON.stringify(err);
        message = '网络环境异常';
    }
    toast(message);
    return {
        errorType: 'ajaxError',
        errmsg: message,
        errcode: 99
    };
};

export default ajaxErrorHandler;



// WEBPACK FOOTER //
// ./src/http/ajaxErrorHandler.js